var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c(
        "a-card",
        {
          style: { marginBottom: "24px" },
          attrs: { loading: _vm.loading, bordered: false },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "inline" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "年级名称" } },
                        [
                          _c("j-dict-select-tag", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              placeholder: "请选择年级",
                              dictCode:
                                "school_grade,grade_name,id,0=delete_flag order by sort_order",
                              allowClear: "",
                            },
                            model: {
                              value: _vm.queryParam.gradeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "gradeId", $$v)
                              },
                              expression: "queryParam.gradeId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "班级名称" } },
                        [
                          _c("j-dict-select-tag", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              placeholder: "请选择班级",
                              dictCode:
                                "school_class,name,id,delete_flag=0 and grade_id=" +
                                (!_vm.queryParam.gradeId
                                  ? -1
                                  : _vm.queryParam.gradeId),
                              async: true,
                            },
                            model: {
                              value: _vm.queryParam.classId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "classId", $$v)
                              },
                              expression: "queryParam.classId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "学生姓名" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入学生姓名" },
                            model: {
                              value: _vm.queryParam.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "name", $$v)
                              },
                              expression: "queryParam.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "时间范围" } },
                        [
                          _c("a-range-picker", {
                            staticStyle: { width: "250px" },
                            attrs: { value: _vm.rangeDate },
                            on: { change: _vm.onRangeChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 4 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.loadData },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            { style: { marginBottom: "24px" }, attrs: { span: 6 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "110px" },
                  attrs: { loading: _vm.loading },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "家长访问次数",
                              value: _vm.total.parentVisitCnt,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "家长平均访问次数",
                              precision: 2,
                              value: _vm.total.parentVisitAvg,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { style: { marginBottom: "24px" }, attrs: { span: 6 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "110px" },
                  attrs: { loading: _vm.loading },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "学生活跃次数",
                              value: _vm.total.studentActivityCnt,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "学生平均活跃次数",
                              precision: 2,
                              value: _vm.total.studentActivityAvg,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { style: { marginBottom: "24px" }, attrs: { span: 6 } },
            [
              _c(
                "a-card",
                {
                  staticStyle: { height: "110px" },
                  attrs: { loading: _vm.loading },
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "提醒次数",
                              value: _vm.total.warnCnt,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "辅导次数",
                              value: _vm.total.tutorCnt,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "split-pane",
        {
          attrs: {
            "min-percent": 20,
            "default-percent": 70,
            split: "vertical",
          },
        },
        [
          _c(
            "template",
            { slot: "paneL" },
            [
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c(
                    "div",
                    { staticClass: "salesCard" },
                    [
                      _c("smooth-line-chart-multid", {
                        attrs: {
                          title: "校园情绪趋势",
                          height: 250,
                          fields: ["愉悦指数", "提醒次数"],
                          dataSource: _vm.schoolMood,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c(
                    "div",
                    { staticClass: "salesCard" },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("smooth-line-chart-multid", {
                                attrs: {
                                  title: "学生活跃情况",
                                  height: 250,
                                  fields: ["activity"],
                                  dataSource: _vm.studentActivity,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("smooth-line-chart-multid", {
                                attrs: {
                                  title: "家长访问情况",
                                  height: 250,
                                  fields: ["visit"],
                                  dataSource: _vm.parentVisit,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c(
                    "div",
                    { staticClass: "salesCard" },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("smooth-line-chart-multid", {
                                attrs: {
                                  title: "性别",
                                  height: 250,
                                  fields: ["男", "女"],
                                  dataSource: _vm.sexData,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("smooth-line-chart-multid", {
                                attrs: {
                                  title: "年龄",
                                  height: 250,
                                  fields: ["10~12", "12~14", "14~16"],
                                  dataSource: _vm.ageData,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c(
                    "div",
                    { staticClass: "salesCard" },
                    [
                      _c("smooth-line-chart-multid", {
                        attrs: {
                          title: "成绩",
                          height: 250,
                          fields: ["语文", "数学", "英语", "物理", "化学"],
                          dataSource: _vm.scoreData,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c(
                    "div",
                    { staticClass: "salesCard" },
                    [
                      _c("smooth-line-chart-multid", {
                        attrs: {
                          title: "其他成绩",
                          height: 250,
                          fields: ["体育", "美术"],
                          dataSource: _vm.otherScoreData,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "paneR" },
            [
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c("rank-list", {
                    attrs: {
                      title: "年级情绪趋势排名",
                      list: _vm.gradeTrendsRanking,
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c("rank-list", {
                    attrs: {
                      title: "班级情绪趋势排名",
                      list: _vm.classTrendsRanking,
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-card",
                {
                  style: { marginBottom: "24px" },
                  attrs: { loading: _vm.loading, bordered: false },
                },
                [
                  _c("rank-list", {
                    attrs: {
                      title: "重点关爱名单",
                      subTitle: ["名字", "提醒数", "愉悦指数"],
                      list: _vm.careTrendsRanking,
                      careAverage: _vm.careAverage,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }